export const SectionWrapper = ({ children, title, fullWidth, card }) => {
    const containerClasses = `
        relative bg-white p-4 shadow-card rounded-xl max-w-5xl
        ${card ? "m-4 mr-4 mb-4 ml-0 w-[30%]" : "mx-auto my-4"}
        ${fullWidth ? "w-full" : card ? "w-[30%]" : "w-[90%]"}
        max-sm:w-[95%]
    `;

    return (
        <div className={containerClasses}>
            {title && (
                <h2 className="w-full text-xl md:text-2xl font-bold text-gray-900 mb-4">
                    {title}
                </h2>
            )}
            {children}
        </div>
    );
};
